import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Flex,
  Heading,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useAuthState from "../../state/auth.state";
import BasePage from "../common/BasePage";

export default function ServiceSelectionPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { role } = useAuthState();
  const services = useMemo(() => {
    const services = [
      {
        id: 0,
        name: t("service_selection_page.video"),
        description: t("service_selection_page.video_description"),
        buttonText: t("service_selection_page.go_to_catalog"),
        buttonTo: "video",
      },
    ];

    if (role === "ROLE_TEACHER") {
      services.push({
        id: 1,
        name: t("service_selection_page.learning_paths"),
        description: t("service_selection_page.learning_paths_description"),
        buttonText: t("service_selection_page.go_to_learning_paths"),
        buttonTo: "learning-paths",
      });
      services.push({
        id: 2,
        name: t("service_selection_page.enrollments"),
        description: t("service_selection_page.enrollments_description"),
        buttonText: t("service_selection_page.go_to_enrollments"),
        buttonTo: "enrollments",
      });
    }

    return services;
  }, [role, t]);

  return (
    <BasePage title={t("service_selection_page.services")}>
      <Flex direction="column" gap={4}>
        {services.map((service) => (
          <Card
            key={service.id}
            direction={{ base: "column", sm: "row" }}
            overflow="hidden"
            variant="outline"
          >
            <Stack>
              <CardBody>
                <Heading size="md">{service.name}</Heading>
                <Text py="2">{service.description}</Text>
              </CardBody>
              <CardFooter>
                <Button
                  onClick={() => navigate(service.buttonTo)}
                  variant="solid"
                  bg="primary.DEFAULT"
                  color="white"
                >
                  {service.buttonText}
                </Button>
              </CardFooter>
            </Stack>
          </Card>
        ))}
      </Flex>
    </BasePage>
  );
}
